/**
 * Niveles de referencia Click & Xperience.
 * Cada nivel es una plantilla que se aplica al proyecto y luego se puede editar
 * libremente fase por fase. Los precios viven en MXN sin IVA.
 *
 * IMPORTANTE: Estos valores son referencia comercial. La fuente de verdad para
 * producción debe vivir en la BD (tabla cx_niveles + cx_nivel_items) para que
 * Roberto/Nataly puedan ajustarlos sin redeploy.
 */
export const CX_NIVELES = {
  base: {
    nombre: 'Base',
    total: 57500,
    fase1: {
      label: 'Modelado y Levantamiento 3D',
      items: [
        { id: 'masterplan', label: 'Modelado de masterplan', precio: 8000 },
        { id: 'tipologias', label: 'Levantamiento de 1-2 tipologías', precio: 4000 },
      ],
    },
    fase2: {
      label: 'Entregables a partir de 3D',
      items: [
        { id: 'renders-ext', label: 'Foto renders exteriores (3)', precio: 8500 },
        { id: 'recorrido-360', label: 'Recorrido virtual 360 (10-25 puntos)', precio: 10000 },
        { id: 'fotogaleria', label: 'Fotogalería (10-20 imágenes)', precio: 3000 },
      ],
    },
    fase3: {
      label: 'Programación e Implementación',
      items: [
        { id: 'programacion', label: 'Programación sub-plataforma', precio: 12000 },
        { id: 'adaptacion', label: 'Adaptación de contenidos', precio: 3500 },
        { id: 'disponibilidades', label: 'Menú de disponibilidades (básico)', precio: 2000 },
        { id: 'personalizacion', label: 'Personalización de tipografía/paleta', precio: 6500 },
      ],
    },
  },
  estandar: {
    nombre: 'Estándar',
    total: 83900,
    fase1: {
      label: 'Modelado y Levantamiento 3D',
      items: [
        { id: 'masterplan', label: 'Modelado de masterplan', precio: 12000 },
        { id: 'tipologias', label: 'Levantamiento de 2-4 tipologías', precio: 8000 },
        { id: 'amenidades', label: 'Levantamiento de 3-5 amenidades', precio: 5000 },
      ],
    },
    fase2: {
      label: 'Entregables a partir de 3D',
      items: [
        { id: 'renders-ext', label: 'Foto renders exteriores (5)', precio: 12500 },
        { id: 'renders-int', label: 'Foto renders interiores (3)', precio: 9000 },
        { id: 'recorrido-360', label: 'Recorrido virtual 360 (40-60 puntos)', precio: 14000 },
        { id: 'video-comercial', label: 'Video comercial (sin voz en off)', precio: 5400 },
        { id: 'fotogaleria', label: 'Fotogalería (20-30 imágenes)', precio: 5500 },
      ],
    },
    fase3: {
      label: 'Programación e Implementación',
      items: [
        { id: 'programacion', label: 'Programación sub-plataforma', precio: 12000 },
        { id: 'adaptacion', label: 'Adaptación de contenidos', precio: 3500 },
        { id: 'disponibilidades', label: 'Menú de disponibilidades (estándar)', precio: 4500 },
        { id: 'personalizacion', label: 'Personalización de tipografía/paleta', precio: 3500 },
      ],
    },
  },
  avanzada: {
    nombre: 'Avanzada',
    total: 145240,
    fase1: {
      label: 'Modelado y Levantamiento 3D',
      items: [
        { id: 'masterplan', label: 'Modelado de masterplan (complejo)', precio: 25000 },
        { id: 'tipologias', label: 'Levantamiento de 4+ tipologías', precio: 15000 },
        { id: 'amenidades', label: 'Levantamiento de 5+ amenidades', precio: 10000 },
      ],
    },
    fase2: {
      label: 'Entregables a partir de 3D',
      items: [
        { id: 'renders-ext', label: 'Foto renders exteriores (8)', precio: 20000 },
        { id: 'renders-int', label: 'Foto renders interiores (6)', precio: 18000 },
        { id: 'recorrido-360', label: 'Recorrido virtual 360 (80-100 puntos)', precio: 20000 },
        { id: 'video-comercial', label: 'Video comercial con voz en off', precio: 10240 },
        { id: 'fotogaleria', label: 'Fotogalería (30-40 imágenes)', precio: 8000 },
        { id: 'tracking', label: 'Tracking shots y animaciones', precio: 4000 },
      ],
    },
    fase3: {
      label: 'Programación e Implementación',
      items: [
        { id: 'programacion', label: 'Programación sub-plataforma (custom)', precio: 25000 },
        { id: 'adaptacion', label: 'Adaptación de contenidos', precio: 8000 },
        { id: 'disponibilidades', label: 'Menú de disponibilidades (avanzado)', precio: 8000 },
        { id: 'personalizacion', label: 'Diseño de menús custom', precio: 4000 },
      ],
    },
  },
};
